module.exports = __webpack_public_path__ + "assets/img/gang1.d31737bc.png";